import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import PerformanceGoals from "./index";
import { LuTarget } from "react-icons/lu";
import ViewReport from "./view";
import EditReport from "./edit";
import { MODULE_PERFORMANCE_GOALS } from "variables/constants";

const performanceGoalsRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Performance & Goals",
		basePath: "performance-goals",
		mainComponent: <PerformanceGoals/>,
	    layout: "/console",	   
	    icon: <LuTarget className="icon-item" />,
	    subTitle:"Performance & Goals",
	    viewComponent: <ViewReport />,
	    createComponent: <EditReport />,
	    editComponent: <EditReport />,
		level:5,
		moduleId: MODULE_PERFORMANCE_GOALS,
	})
]

export default performanceGoalsRoutes;